import React, { useEffect, useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Form, FormikProvider, useFormik } from "formik";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import {
  addKra,
  editKra,
  getAllKras,
} from "../../../redux/features/appraisalSlice";

const AddKra = ({ edit, title, description, kraId, dispatchData, externalOpen, setExternalOpen }) => {
  const [internalOpen,setInternalOpen]=useState(false)
  const open=externalOpen!==undefined?externalOpen:internalOpen;
  const setOpen=(value)=>{
    if(externalOpen!==undefined){
      setExternalOpen(value);
    }else{
      setInternalOpen(value);
    }
  }
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.appraisal);

  const ValidationSchema = Yup.object().shape({
    appraisal_library_name: Yup.string().required(
      "Enter a valid value for KRA"
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      appraisal_library_name: title || "",
      appraisal_library_description: description || "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      const payload = {
        type: "kra",
        data: [
          {
            ...values,
          },
        ],
      };
      if (edit) {
        const data = {
          ...values,
          appraisal_library_id: kraId || "",
        };
        dispatch(editKra(data)).then((res) => {
          console.log(res);
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            if (!dispatchData) {
              dispatch(getAllKras());
            }
            dispatch(getAllKras(dispatchData));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
            // setOpen(false);
          }
        });
      } else {
        dispatch(addKra(payload)).then((res) => {
          if (res.payload.status === "success") {
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            if (!dispatchData) {
              dispatch(getAllKras());
            }
            dispatch(getAllKras(dispatchData));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
            // setOpen(false);
          }
        });
      }
    },
  });

  return (
    <GlobalDialog
      title={edit ? "Edit KRA" : "Add KRA"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        edit ? (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            <Icon icon="mdi:pencil" width={18} height={18} />
          </Button>
        ) : (
          <Button
          sx={{boxShadow:'none'}}
            size="small"
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Add KRA
          </Button>
        )
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="appraisal_library_name"
                    value={formik.values.appraisal_library_name}
                    error={
                      formik.touched.appraisal_library_name &&
                      Boolean(formik.errors.appraisal_library_name)
                    }
                    helperText={formik.errors.appraisal_library_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Title"
                  />
                  <TextField
                    name="appraisal_library_description"
                    multiline
                    rows={3}
                    value={formik.values.appraisal_library_description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    {edit ? (
                      <UpdateButton
                        disabled={loading}
                        size="small"
                        type="submit"
                      >
                        {loading ? "Please wait..." : "Update"}
                      </UpdateButton>
                    ) : (
                      <SubmitButton
                        disabled={loading}
                        size="small"
                        type="submit"
                      >
                        {loading ? "Please wait..." : "Save"}
                      </SubmitButton>
                    )}
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddKra;
